import appCorporateInvoiceItem from "../../views/appCustomers/corporateInvoiceItem.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("corporateinvoiceitem", {
    url: "corporateinvoiceitem/:id",
    parent: "app",
    views: {
      view: {
        template: appCorporateInvoiceItem,
      },
    },
    reloadOnSearch: false,
    data: { title: "CorporateInvoiceItem" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/corporateInvoiceItem/corporateInvoiceItem.urls.js